import { Component, inject, Input } from '@angular/core';
import { MaterialModule } from '../../shared/material/material.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-shopping-card',
    standalone: true,
    imports: [MaterialModule],
    templateUrl: './shopping-card.component.html',
    styleUrl: './shopping-card.component.scss'
})
export class ShoppingCardComponent {
  @Input() showProviderPF: boolean = true;

  private deviceService = inject(DeviceDetectorService);
  private authService = inject(AuthService);
  
  isMobile = this.deviceService.isMobile();

  login(): void {
    this.authService.loginWithRedirect();
  }
}
